import { useTranslation } from "react-i18next";
import Select from "react-select";
import "./multi-select.scss";

export default function MultiSelectAtom(props) {
	const {
		selectedOption = [],
		placeholder,
		options = [],
		onChange,
		error = "",
		required = false,
		isMulti = true,
		label = "",
		...rest
	} = props;
	const { t } = useTranslation();

	// DS-aligned custom styles (mirrors DropdownAtom tokens)
	const customStyles = {
		control: (provided, state) => ({
			...provided,
			borderColor: error ? "#ef4444" : (state.isFocused ? "#14c3b8" : "#e2e8f0"),
			borderRadius: "7px",
			fontSize: "13px",
			boxShadow: state.isFocused
				? error
					? "0 0 0 3px rgba(239,68,68,.12)"
					: "0 0 0 3px rgba(20,195,184,.12)"
				: "none",
			"&:hover": {
				borderColor: error ? "#ef4444" : (state.isFocused ? "#14c3b8" : "#cbd5e1"),
			},
			transition: "border-color 0.15s, box-shadow 0.15s",
		}),
		placeholder: (provided) => ({ ...provided, color: "#94a3b8", fontSize: "13px" }),
		singleValue: (provided) => ({ ...provided, color: "#0f172a", fontSize: "13px" }),
		menu: (provided) => ({
			...provided,
			zIndex: 9999,
			borderRadius: "7px",
			border: "1px solid #e2e8f0",
			boxShadow: "0 4px 8px -2px rgba(15,23,42,.06)",
		}),
		menuList: (provided) => ({ ...provided, padding: "4px" }),
		menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
		option: (provided, state) => ({
			...provided,
			borderRadius: "5px",
			fontSize: "13px",
			color: state.isDisabled ? "#94a3b8" : "#0f172a",
			backgroundColor: state.isDisabled
				? "transparent"
				: state.isSelected
					? "#14c3b8"
					: state.isFocused
						? "#e6faf8"
						: "transparent",
			"&:active": { backgroundColor: "#c8f3ef" },
			padding: "7px 10px",
		}),
		multiValue: (provided) => ({
			...provided,
			backgroundColor: "#e6faf8",
			borderRadius: "5px",
		}),
		multiValueLabel: (provided) => ({
			...provided,
			color: "#0b8a82",
			fontSize: "12px",
			fontWeight: 500,
		}),
		multiValueRemove: (provided) => ({
			...provided,
			color: "#0b8a82",
			"&:hover": { backgroundColor: "#c8f3ef", color: "#054a46" },
		}),
		indicatorSeparator: (provided) => ({ ...provided, backgroundColor: "#e2e8f0" }),
		clearIndicator: (provided) => ({
			...provided,
			color: "#94a3b8",
			"&:hover": { color: "#475569" },
		}),
		dropdownIndicator: (provided) => ({
			...provided,
			color: "#94a3b8",
			"&:hover": { color: "#475569" },
		}),
	};

	return (
		<div className="multi-select-wrapper">
			{label && (
				<label>
					{label}
					{required && <span className="text-danger"> *</span>}
				</label>
			)}
			<Select
				defaultValue={selectedOption}
				onChange={onChange}
				options={options}
				isMulti={isMulti}
				isSearchable
				placeholder={placeholder ?? ""}
				styles={customStyles}
				menuPosition="fixed"
				menuPlacement="auto"
				menuPortalTarget={document.body}
				{...rest}
			/>
			{error && <p className="multi-select-error">{t(error)}</p>}
		</div>
	);
}
